import React from 'react';
import { useDropzone } from 'react-dropzone';

import { Icon, Progress, Message } from 'semantic-ui-react';

import { FormFieldBase } from './FormFieldBase';
import { byteSize } from '../../utils/utils';

class FormFileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      files: [],
      errors: []
    };
  }

  cleanFileName = (str) => {
    return str.replace(/([^a-z0-9 -.]+)/gi, '').replace(/ /g, '_');
  };

  addFiles = (newFiles) => {
    const { files } = this.state;

    const combinedFiles = [...files, ...newFiles];
    if (combinedFiles.length > 3) {
      this.setState({ errors: ['Maximum of 3 attachments allowed.'] });
    } else {
      this.props.onChange(combinedFiles);
      this.setState({ files: combinedFiles });
    }
  };

  removeFile = (filename) => {
    const oldFiles = this.state.files;
    const files = oldFiles.filter((file) => file.name !== filename);
    this.props.onChange(files);
    this.setState({ files });
  };

  handleDrop = (files) => {
    this.setState({ errors: [] });
    this.addFiles(files);
  };

  handleRejectedDrop = (files) => {
    const types = [
      'application/pdf',
      'application/csv',
      'image/jpg',
      'image/jpeg',
      'image/png'
    ];
    const customErrors = [];
    files.forEach(({ file, errors }) => {
      if (file.size > 2e6) {
        customErrors.push(
          `File "${file.name}" exceded the maximum 2MB file size limit.`
        );
      }
      if (!types.includes(file.type)) {
        customErrors.push(
          `File "${file.name}" of type "${file.type}" is not a valid attachment file type.`
        );
      }
    });
    this.setState({ errors: customErrors });
  };
  removeError = (err) => {
    let newErrs = this.state.errors.map((error) => error !== err);
    this.setState({ errors: newErrs });
  };

  render() {
    const {
      placeholder,
      onChange,
      disabled,
      className,
      isUploading,
      uploadProgress,
      innerContent,
      ...otherProps
    } = this.props;
    const { files, errors } = this.state;

    return (
      <React.Fragment>
        <FormFieldBase
          className={`FormFileUpload ${className || ''}`}
          disabled={disabled}
          component={
            <Dropzone
              disabled={disabled}
              innerContent={innerContent}
              onDropAccepted={this.handleDrop}
              onDropRejected={this.handleRejectedDrop}
            />
          }
          {...otherProps}
        />
        {!!errors &&
          errors.length > 0 &&
          errors.map((err, i) => (
            <Message negative key={i}>
              {err}
            </Message>
          ))}
        {!!files && !!files.length && (
          <ul className="file-upload">
            {files.map((file) =>
              isUploading ? (
                <li key={file.path}>
                  <span className="file-name">{file.path}</span>
                  <Progress
                    size="small"
                    color="green"
                    percent={uploadProgress}
                  />
                </li>
              ) : (
                <li key={file.path}>
                  <span className="file-name">
                    {file.path} - {byteSize(file.size, 0)}
                  </span>
                  <Icon
                    color="red"
                    name="x"
                    link
                    onClick={() => this.removeFile(file.name)}
                  />
                </li>
              )
            )}
          </ul>
        )}
      </React.Fragment>
    );
  }
}

const Dropzone = ({ innerContent, disabled, ...props }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    ...props,
    multiple: true,
    maxSize: 2e6, // 2MB => 3,000,000 bytes
    accept: '.jpeg, .png, .jpg, .pdf, .csv, .doc, .docx, .xls, .xlsx',
    noClick: disabled,
    noKeyboard: disabled
  });

  return (
    <div className="dropzone" {...getRootProps()}>
      <input tabIndex="-1" {...getInputProps()} />
      {isDragActive ? (
        <p className="drop-inner-text">Drop the files here ...</p>
      ) : innerContent ? (
        innerContent
      ) : (
        <p className="drop-inner-text">
          Drop attachment files here or{' '}
          <button tabIndex="-1" className="link">
            choose a file
          </button>
        </p>
      )}
    </div>
  );
};

export default FormFileUpload;
